// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  changeStatusPurchaseOrder,
  createPurchaseOrder,
  deletePurchaseOrder,
  getDetailPurchaseOrder,
  getListPurchaseOrder,
  updatePurchaseOrder,
} from './purchaseOrderThunk';

export interface IPurchaseOrderState {
  isRefreshPurchaseOrderList: boolean;
}

export const initialState: IPurchaseOrderState = {
  isRefreshPurchaseOrderList: false,
};

const purchaseOrderSlice = createSlice({
  name: 'purchaseOrder',
  initialState,
  reducers: {
    setRefreshPurchaseOrderList(state, action) {
      state.isRefreshPurchaseOrderList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list purchaseOrder
    builder
      .addCase(getListPurchaseOrder.pending, (_state) => {})
      .addCase(getListPurchaseOrder.fulfilled, (state) => {
        state.isRefreshPurchaseOrderList = false;
      })
      .addCase(getListPurchaseOrder.rejected, (_state) => {});

    // GET: Get detail purchaseOrder
    builder
      .addCase(getDetailPurchaseOrder.pending, (_state) => {})
      .addCase(getDetailPurchaseOrder.fulfilled, (_state) => {})
      .addCase(getDetailPurchaseOrder.rejected, (_state) => {});

    // POST: Create purchaseOrder
    builder
      .addCase(createPurchaseOrder.pending, (_state) => {})
      .addCase(createPurchaseOrder.fulfilled, (state) => {
        state.isRefreshPurchaseOrderList = true;
      })
      .addCase(createPurchaseOrder.rejected, (_state) => {});

    // PUT: Update  purchaseOrder
    builder
      .addCase(updatePurchaseOrder.pending, (_state) => {})
      .addCase(updatePurchaseOrder.fulfilled, (state) => {
        state.isRefreshPurchaseOrderList = true;
      })
      .addCase(updatePurchaseOrder.rejected, (_state) => {});

    // DELETE: Delete purchaseOrder
    builder
      .addCase(deletePurchaseOrder.pending, (_state) => {})
      .addCase(deletePurchaseOrder.fulfilled, (state) => {
        state.isRefreshPurchaseOrderList = true;
      })
      .addCase(deletePurchaseOrder.rejected, (_state) => {});

    // DELETE: Change status purchaseOrder
    builder
      .addCase(changeStatusPurchaseOrder.pending, (_state) => {})
      .addCase(changeStatusPurchaseOrder.fulfilled, (state) => {
        state.isRefreshPurchaseOrderList = true;
      })
      .addCase(changeStatusPurchaseOrder.rejected, (_state) => {});
  },
});

// Action
export const purchaseOrderActions = purchaseOrderSlice.actions;

// Selectors
// Reducer
const purchaseOrderReducer = purchaseOrderSlice.reducer;
export default purchaseOrderReducer;
